module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 136.5008b29a.png";